<template>
    <div>
        <div id="sendcomplite" v-if="shownot">
            <!--            <notifications transition-name="notification-list" transition-mode="out-in"></notifications>-->
        </div>
        <div id="order" v-else>
            <div v-if="showbuttons" class="row" id="static-top"
                 style="position: fixed;z-index: 9999;background: white;min-height: 60px;top:0px; border: 1px solid #e8e7e3;width: 100%;">
                <!--                <div style="margin-top: 15px;">-->
                <div class="col-xs-2" style="padding-left: 20px;padding-top: 25px;">
                    <router-link to="/catalog" style="color: black;">
                        <span @click="" style="font-size: 20px;"><i class="ti-arrow-left"></i></span>
                    </router-link>
                </div>
                <div class="col-xs-8">
                    <center><h3>Заказ</h3></center>
                </div>
                <div class="col-xs-2" style="padding-left: 6px;padding-top: 25px;">
                    <span style="font-size: 20px;" @click="clear_order()"><i class="ti-trash"></i></span>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-8 col-sm-12" style="padding: 3px;">
                    <div class="card" style="margin-top: 40px;">
                        <div class="card-content">
                            <div class="row" v-for="(item, index) in order" v-bind:key="item.good"
                                 @click="showSwal('input-field', item)">
                                <hr style="margin: 10px;"/>
                                <div class="col-xs-9">
                                    {{item.quantity + '&#8195;x&emsp;' + item.name}}
                                </div>
                                <div class="col-xs-3" style="text-align: right; padding: 0;">
                                    {{Math.floor(item.price * item.quantity * item.multiplier * 100) / 100}} p.
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="card">
                        <div class="card-content">
                            <div class="row">
                                <div class="col-xs-12">
                                    <div class="form-group">
                                        <label for="Textarea1">Коментарий</label>
                                        <textarea class="form-control" id="Textarea1" rows="1" v-model="info" >{{info}}</textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-content">
                            <div class="row">
                                <div class="col-xs-4">
                                    <span style="font-size: 20px;">Итого:</span>
                                </div>
                                <div class="col-xs-8">
                                    <p style="font-size: 20px;text-align: right;">{{itog}}</p>
                                </div>
                            </div>
                            <div v-if="!itog">
                                <hr/>
                                <p>Вы еще не создали заказ, перейдите в каталог для выбора товаров.</p>
                            </div>
                        </div>
                    </div>
                    <div class="card" style="margin-bottom: 160px;">
                        <div class="card-content">
                            <div class="row" style="margin: 6px;">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="showbuttons&&itog>0" class="row" id="static-order"
                 style="position: fixed;z-index: 9990;background: white;min-height: 60px;bottom:60px;width: 100%;">
                <div class="col-xs-12" style=" padding-left: 4%; padding-bottom: 10px;">
                    <router-link to="/order">
                        <button class="btn btn-success btn-fill btn-wd" :disabled="btnOff" style="height: 60px; width: 100%;"
                                @click="save_order()"><span class="center">Отправить поставщику</span></button>
                    </router-link>
                </div>
            </div>
            <div class="row" id="menu"
                 style="position: fixed;z-index: 9990;background: rgba(4,7,6,0.27);height: 60px;bottom:0px;width: 100%;">
                <div class="col-xs-12"
                     style=" padding-left: 4%; padding: 0px;border-top:1px ridge rgba(4,7,6,0.16);">
                    <div class="col-xs-3" style="background: white;padding: 10px;">
                        <router-link to="/catalog">
                            <center>
                                <i class="ti-agenda" style="font-size: 20px;padding-top:6px;"></i>
                                <br/>
                                <span style="font-size: 1em;">Каталог</span>
                            </center>
                        </router-link>
                    </div>
                    <div class="col-xs-3" style="background: white;padding: 10px;background: #ececec">
                        <router-link to="/order">
                            <center>
                                <i class="ti-shopping-cart" style="font-size: 20px;padding-top:6px;"></i>
                                <br/>
                                <span style="font-size: 1em;">Заказ</span>
                            </center>
                        </router-link>
                    </div>
<!--                    <div class="col-xs-3" style="background: white;padding: 10px;">-->
<!--                        <router-link to="/obmen">-->
<!--                            <center>-->
<!--                                <i class="ti-reload" style="font-size: 20px;padding-top:6px;"></i>-->
<!--                                <br/>-->
<!--                                <span style="font-size: 1em;">Обновить</span>-->
<!--                            </center>-->
<!--                        </router-link>-->
<!--                    </div>-->
                    <div class="col-xs-3" style="background: white;padding: 10px;">
                        <router-link to="/orderslist">
                            <center>
                                <i class="ti-timer" style="font-size: 20px;padding-top:6px;"></i>
                                <br/>
                                <span style="font-size: 1em;">История</span>
                            </center>
                        </router-link>
                    </div>
                    <div class="col-xs-3" style="background: white;padding: 10px;">
                        <router-link to="/settings">
                            <center>
                                <i class="ti-more-alt" style="font-size: 20px;padding-top:6px;"></i>
                                <br/>
                                <span style="font-size: 1em;">Ещё</span>
                            </center>
                        </router-link>
                    </div>
                    <!--                <div class="col-xs-2" style="background: white;padding: 5px;">-->
                    <!--                    <center>-->
                    <!--                        <i class="ti-clipboard" style="font-size: 20px;padding-top:6px;"></i>-->
                    <!--                        <br/>-->
                    <!--                        <span style="font-size: 1em;">Профиль</span>-->
                    <!--                    </center>-->
                    <!--                </div>-->
                    <!--                <router-link to="/order">-->
                    <!--                    <p>chno-to</p>-->
                    <!--&lt;!&ndash;                    <button class="btn btn-warning btn-fill btn-wd" style="height: 60px; width: 100%;" @click=""><span class="center" style="padding-left:60px; ">Корзина</span><span class="pull-right">{{sum}} руб.</span></button>&ndash;&gt;-->
                    <!--                </router-link>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>

  import swal from 'sweetalert2'
  import OrderInfo from './OrderInfo'
  // import VueNotify from 'vue-notifyjs'
  import 'vue-notifyjs/themes/default.css'
  // Vue.use(VueNotify)

  export default {
    name: 'Order',
    components: {OrderInfo},
    // props: ['itog', 'order'],
    data () {
      return {
        info: '',
        settings: undefined,
        shownot: false,
        resp: {},
        showbuttons: true,
        itog: 0,
        link: 'https://images.akitorg.ru/images/',
        order: [],
        btnOff: false,
        distr: undefined,
        token: undefined,
        regcode: undefined
      }
    },
    mounted () {
      if (localStorage.getItem('curentDist')) {
        this.distr = localStorage.getItem('curentDist')
      }
      this.$db.distributors.where('dbase').equals(this.distr).toArray()
        .then(x => {
          this.token = x[0].token
          this.regcode = x[0].regcode
        })

      this.load_save_order()
      this.checksettings()
      this.getphotolink()
    },
    methods: {
      getphotolink () {
        this.link = this.link + this.regcode + '/goods_photos/'
      },
      load_save_order () {
        // this.$db.order.toArray().then( x => this.order = x)
        let p = this.$db.order.toArray()
        p.then(x => {
          this.order = x
          this.order_sum()
        })
      },
      order_sum () {
        var itog = 0
        this.order.forEach(function (item) {
          itog = itog + item.price * item.quantity * item.multiplier
        })
        itog = Math.floor(itog * 100) / 100
        this.itog = itog
        // console.log('this.itog = ' + this.itog)
        return itog
      },
      photo_src: function (good) {
        if (good.isgroup) {
          return '<i class="ti-folder" style="font-size:2rem;"></i>'
          // eslint-disable-next-line eqeqeq
        } else if (good.photo != '') {
          return '<img src="' + this.link + good.photo + '" alt="..." style="width: 5rem;"/>'
        } else {
          return '<i class="ti-image" style="font-size:3rem;"></i>'
          // return ''
        }
      },
      delete_item (i) {
        // console.log(i)
        this.order.splice(i, 1)
      },
      clear_2 (i) {
        // console.log(i)
        swal({
          title: 'Точно удалить?',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false
        }).then((result) => {
          if (result) {
            // console.log(i)
            // console.log('result')
            this.$db.order.where({'good': i}).delete()
            this.load_save_order()
            // this.order = []
            // this.$db.order.clear()
            // this.order_sum()
            // this.order_tap = false
          }
          // eslint-disable-next-line handle-callback-err
        })
        //   .catch((error) => {
        //   // console.log(error)
        // })
      },
      showSwal (type, good) {
        if (good.isgroup) {
          return
        }
        var quantity = 0
        var photo = ''
        quantity = good.quantity
        if (good.photo !== '' && good.photo.length > 4) {
          // photo = '<i class="ti-image" style="font-size:3rem;"></i>'
          photo = '<img src="' + this.link + good.photo + '" alt="..." style="width: 40%; height: 40%; max-height: 40%;">'
        } else {
          photo = ''
        }
        this.showbuttons = false
        swal({
          title: good.name,
          html: '<div class="form-group">' +
            photo +
            '</div>',
          input: 'number',
          inputValue: quantity,
          inputPlaceholder: 'Введите количество',
          // showCancelButton: true,
          showCloseButton: true,
          // cancelButtonColor: '#d33',
          // cancelButtonText:
          //   '<i class="ti-trash"></i>',
          reverseButtons: true
        }).then((result) => {
          // console.log('result ' + result)
          if (result > 0) {
            this.set_q(good, result)
          } else if (result === '0' | result === '') {
            // console.log('else ' + result)
            this.dellgood(good.good)
          }
        })
          .catch((x) => {
            // console.log(x)
          })
          .finally((x) => {
            this.showbuttons = true
          })
      },
      set_q (good, q) {
        var dsum = Math.floor(q * good.price * 100) / 100
        var b = this.order.findIndex(x => x.good === good.good)
        if (b >= 0) {
          this.$set(this.order, b, {
            good: good.good,
            quantity: q,
            price: good.price,
            name: good.name,
            photo: good.photo,
            unit: 0,
            dsum: dsum,
            multiplier: 1,
            discount: 0,
            project: 0,
            info: ''
          })
        } else {
          this.order.push({
            good: good.good,
            quantity: q,
            price: good.price,
            name: good.name,
            photo: good.photo,
            unit: 0,
            dsum: dsum,
            multiplier: 1,
            discount: 0,
            project: 0,
            info: ''
          })
        }
        this.$db.order.bulkPut(this.order)
        this.order_sum()
      },
      dellgood (goodid) {
        var a = this.order.findIndex(x => x.good === goodid)
        this.order.splice(a, 1)
        this.$db.order.where('good').equals(goodid).delete()
        this.order_sum()
      },
      clear_order () {
        swal({
          title: 'Точно удалить весь заказ?',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false
        }).then((result) => {
          if (result) {
            this.order = []
            this.$db.order.clear()
            this.order_sum()
            this.order_tap = false
          }
          // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
          console.log(error)
        })
      },
      notification (type, text, icon) {
        if (icon === '') {
          icon = 'ti-email'
        }
        this.$notify({
          component: {
            template: text
          },
          icon: 'ti-email',
          horizontalAlign: 'right', // right | center | left
          verticalAlign: 'top', // top | bottom
          type: type  // info | success | warning | danger
        })
      },
      save_order () {
        // this.shownot = true
        this.btnOff = true
        this.notification('warning', '<span>....</span>')
        this.notification('warning', '<span>Отправляю заказ</span>')
        let time = new Date().toISOString()
        let dt = time.slice(0, 10) + ' ' + time.slice(11, 19)
        let sum = this.order_sum()
        this.$db.orders.put({goods: this.order, sum: sum, dt: dt, status: 'Сохранен но не отправлен', info: this.info})
          .then((orderid) => {
            let goodstosend = JSON.parse(JSON.stringify(this.order))
            for (let key in goodstosend) {
              delete goodstosend[key].name
              delete goodstosend[key].photo
              delete goodstosend[key].discount
              // delete goodstosend[key].multiplier
              delete goodstosend[key].project
              // delete goodstosend[key].unit
              delete goodstosend[key].info
            }
            this.resp.goods = goodstosend
            this.resp.number = orderid
            this.resp.ddate = dt
            this.resp.info = this.info
            // console.log('this.resp')
            // console.log(this.resp)
            this.order_tap = false
            this.send_order()
          })
          .catch((error) => {
            this.shownot = false
            console.log(error)
          })
      },
      sleep (ms) {
        return new Promise(resolve => setTimeout(resolve, ms))
      },
      checksettings () {
        this.$db.settings.toArray()
        // eslint-disable-next-line no-return-assign
          .then((x) => {
            if (x.length !== 0) {
              this.settings = x[0]
              // console.log(this.settings)
            } else {
              console.log('А нету настроек')
            }
          })
          .catch((e) => {
            console.log(e)
          })
      },
      send_order () {
        this.message = 'пришел в load_order'
        const axios = require('axios')
        let data = JSON.stringify(this.resp)
        axios({
          method: 'post',
          url: 'https://webzakaz.akitorg.ru/i.php',
          headers: {'X-User-Id': this.distr, 'X-Authorization': this.token, 'X-Route': 'add_order'},
          data: data
        })
          .then((res) => {
            // console.log(res)
            if (res.status === 200) {
              if (res.data.id > 0) {
                // переход
                // console.log('ОТПРАВИЛ удачно)))')
                // this.$db.settings.update(this.settings.token, {lastconnection: Date.now()})
                this.$db.orders.update(this.resp.number, {status: 'Отправлен поставщику'})
                this.notification('success', '<span>Заказ отправлен</span>')
                this.$db.order.clear()
                this.order = []
                this.sleep(2000).then(() => {
                  this.$router.push({name: 'OrdersList'})
                })
              }
            }
          })
          .catch((error) => {
            // console.log('error.response.data')
            // console.log(error.response.data)
            this.notification('danger', '<span>' + error + '</span>')
            this.shownot = false
            this.sleep(1000).then(() => {
              this.shownot = false
            })
          })
      }
    }
  }
</script>

<style scoped>
    .row {
        margin: 0px;
    }

    a {
        color: #000000;
    }
</style>


// WEBPACK FOOTER //
// src/components/UIComponents/Custom/Order.vue